export const DOMAIN_NAME = 'common';